import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServiceBaseService } from '../core/service-base.service';
import { BeekeeperProducts } from './beekeeper-products';
import { GenericDataService } from '../shared/generic-data.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BeekeeperProductsService extends GenericDataService<BeekeeperProducts> {
  endpointName = '/beekeeper-products';

  constructor(http: HttpClient, serviceBase: ServiceBaseService) {
    super(http, serviceBase);
  }

  getQrCode(beekeeperProductsId: string): Observable<Blob> {
    return this.http.get(
      `${this.serviceBase.getServiceBase()}${this.endpointName}/${beekeeperProductsId}/qrcode`,
      { ...this.serviceBase.getHeaders(), responseType: 'blob' }
    );
  }
}
